import { HStack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

/** Section title of the score card: AI only recommends; the final decision belongs to a recruiter. */
const AiRecommendationHeader = (props) => {
    const { t } = useTranslation("models");
    return (
        <HStack w="full" columnGap={2} rowGap={0} align="baseline" flexWrap="wrap" {...props}>
            <Text fontSize="md" fontWeight={700} color="gray.900">{t("candidateDetailPage.aiNoticeTitle")}</Text>
            <Text fontSize="xs" color="gray.500">{t("candidateDetailPage.aiNoticeText")}</Text>
        </HStack>
    );
};

export default AiRecommendationHeader;
